/* Original name @uswitch/trustyle.frozen-input */

import { Fragment, useEffect, useState } from 'react'
import { useThemeUI } from 'theme-ui'
import { TruEdit } from '@uswitch/spark-icons/tru'

const UswitchNavy = '#141424'

const editIconWidth = 69
export const FrozenInput = ({ text, freezable, inputRef, children }) => {
  const [frozen, setFrozen] = useState(freezable && !!text)
  const { theme } = useThemeUI()
  const iconColor =
    (theme && theme.colors[theme.elements.input?.frozen?.button?.color]) || UswitchNavy

  useEffect(() => {
    if (freezable && !frozen && !!text && inputRef && inputRef.current) {
      inputRef.current.focus()
    }
  }, [frozen])

  if (!frozen) {
    return <Fragment>{children}</Fragment>
  }

  return (
    <Fragment>
      <div
        sx={{
          fontSize: 'xs',
          fontWeight: 'base',
          lineHeight: '1.29',
          alignItems: 'center',
          backgroundColor: 'frozen-bg',
          display: 'flex',
          height: '64px',
          justifyContent: 'space-between',
          variant: 'elements.input.frozen.base',
        }}
      >
        <p
          sx={{
            color: 'text',
            overflow: 'hidden',
            padding: '0 24px',
            textOverflow: 'ellipsis',
            width: `calc(100% - ${editIconWidth}px)`,
            variant: 'elements.input.frozen.text',
            m: 0,
          }}
        >
          {text}
        </p>
        <button
          aria-label='Edit Value'
          sx={{ variant: 'elements.input.frozen.button' }}
          onClick={() => setFrozen(false)}
        >
          <TruEdit color={iconColor} />
        </button>
      </div>

      <div sx={{ variant: 'elements.input.frozen.hidden' }}>{children}</div>
    </Fragment>
  )
}
